module.exports = __webpack_public_path__ + "media/images/partners/banque-mondiale-03fdd9610fed4e7ec8c532540efd3f3d.png";